module.exports = __webpack_public_path__ + "static/integration-f103dd0d26915183d3aed4780926ff95.png";